import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { SIZE } from '../../../../constants/size'
import { useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'

import { AccessField as DefaultAccessField } from './AccessField'
import { NameField } from './NameField'

import * as styles from './FormFields.module.css'

function FormFields({
  AccessField = DefaultAccessField,
  ContentComponent = Content,
  contentComponentProps: {
    size: contentSize = SIZE.X_LARGE,
    ...contentComponentProps
  } = EMPTY_OBJECT,
  notifications,
  outboundUuid,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const user = useUserData()

  const isStaffUserAcc = isStaffUser(user)

  const { dirty, isSubmitting } = useFormikContext()

  function handleCancel() {
    onCancel({ dirty })
  }

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        className: styles.actions,
        submitProps: {
          isLoading: isSubmitting,
        },
      }}
    >
      <ContentComponent {...contentComponentProps} size={contentSize}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer className={styles.fieldsContainer}>
          <NameField />
          {AccessField && isStaffUserAcc && !outboundUuid ? (
            <AccessField />
          ) : null}
        </FormFieldsContainer>
      </ContentComponent>
    </FormBody>
  )
}

export default FormFields
